package br.com.texeratx.boardgametimeapp.domain.usecases.upload

import br.com.texeratx.boardgametimeapp.data.repository.UploadRepository

class UploadPlayerImageUseCase(
    private val uploadRepository: UploadRepository
) {
    suspend operator fun invoke(
        bytes: ByteArray,
        fileName: String,
        mimeType: String
    ): Result<String> {
        return uploadRepository.uploadPlayerImage(
            bytes = bytes,
            fileName = fileName,
            mimeType = mimeType
        )
    }
}
